export const CardType = Object.freeze({
	Visa: 'Visa',
	// For 'Master' AccountType, We found value discrepency between GET and POST/PUT call
	// The Payment GET call return AccountType value as 'Master'
	Master: 'Master',
	// The payment POST/PUT call expected AccountType value as 'MasterCard' instead of 'Master'
	MasterCard: 'MasterCard',
	Discover: 'Discover',
	// GET
	Amex: 'AMEX',
	// PUT
	AmericanExpress: 'AmericanExpress',
});
